const STORAGE_KEY = 'notAvailCount';
export const getNotAvailCount = () => Number(sessionStorage.getItem(STORAGE_KEY) || 0);
export const increaseNotAvailCount = () => {
    sessionStorage.setItem(STORAGE_KEY, String(getNotAvailCount() + 1));
};
export const resetNotAvailCount = () => {
    sessionStorage.removeItem(STORAGE_KEY);
};
